import { action, computed, makeObservable } from 'mobx';

import { UserLoginRequest } from 'entities/endpoints/user.login';
import { rootStore } from 'stores/RootStore';
import { ILocalStore } from 'stores/interfaces';
import { EntryText } from 'stores/models';
import {
  orderValidators,
  validateIsEmail,
  validateNotEmpty,
} from 'utils/validators';

import { TEXTS_CONFIG } from './texts';

type PrivateFields = '_loginParams';

class LoginStore implements ILocalStore {
  constructor() {
    makeObservable<LoginStore, PrivateFields>(this, {
      _loginParams: computed,
      submit: action.bound,
    });
  }

  readonly fieldsMap = {
    login: new EntryText({
      defaultValue: '',
      validator: orderValidators<string>(
        validateNotEmpty(TEXTS_CONFIG.EMAIL_FIELD_EMPTY),
        validateIsEmail(TEXTS_CONFIG.EMAIL_FIELD_VALID)
      ),
    }),
    password: new EntryText({
      defaultValue: '',
      validator: validateNotEmpty(TEXTS_CONFIG.PASSWORD_FIELD_EMPTY),
    }),
  };

  private get _loginParams(): UserLoginRequest | null {
    const email = this.fieldsMap.login.toServerFormat;

    const password = this.fieldsMap.password.toServerFormat;

    if (!email || !password) {
      return null;
    }

    return {
      email,
      password,
    };
  }

  async submit(): Promise<void> {
    if (!this._loginParams) {
      return;
    }

    await rootStore.userStore.login(this._loginParams);
  }

  destroy() {
    Object.values(this.fieldsMap).forEach((field) => field.destroy());
  }
}

export default LoginStore;
